import { createResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-issue-navigator-global-scope-enrolment", jiraSpaEntry: "async-resource-issue-navigator-global-scope-enrolment" */ './services'
	);

/**
 * The purpose of this resource is to determine whether or not the user is enrolled in NIN in the global scope. It
 * returns a boolean value: true if the user is enrolled in NIN in the global scope, false otherwise. This is used as
 * input by the GinRedirect component (src/packages/routes/src/common/ui/redirect/gin-redirect/index.js) to decide
 * whether to load NIN, or redirect to the legacy GIN experience.
 *
 * The server maintains a user preference and an application property which are used to determine if the user should be
 * enrolled in NIN in the global scope.
 */
export const isNinGlobalScopeEnrolmentEnabledResource = createResource<boolean>({
	type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
	getKey: () => 'ninGlobalScopeEnrolment',
	getDataLoader,
});
